export default __webpack_public_path__ + "static/assets/1ffad86db571140abc6d5e0776b008a1.svg";